import React, { useEffect, useState } from 'react'
import { CustomerAddressRow, OrderItems, SideBackNav } from '../../../../components/organisms';
import { OrderShipmentDetailRow } from './OrderShipmentDetailRow';
import { useLocation } from 'react-router';
import { getOrderItems } from '../../../../utils';

export const OrderDetailsComp = ({ onBack }) => {
    const [data, setData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const { state } = useLocation();
    const { customer, time, date, orderNumber, url, value, customerAddress, orderReadyForShipmentDateTime, orderId, note, lineItems } = state;
    const orderValue = value.toLocaleString({ maximumFractionDigits: 2 });
    const collectedDate = orderReadyForShipmentDateTime ? orderReadyForShipmentDateTime.slice(0, 10) : "N/A"
    const collectTime = orderReadyForShipmentDateTime ? orderReadyForShipmentDateTime.slice(11, 16) : "N/A"

    useEffect(async () => {
        setIsLoading(true)
        // const {itemsAndLinks: res} = await getOrderItems(orderId);

        // const readyForShipmentItems = res?.filter(item => item.status ===2);
        setData(lineItems);
        setIsLoading(false);
    }, []);

    return (
        <div className='new-orders-screen'>
            <div className="dashboard-content-post body" style={{marginLeft:'0px'}}>
                <SideBackNav
                    title={'Back'}
                    onClick={onBack}
                    orderNumber={`Order ${orderNumber}`}
                    statusTitle={'Ready for Shipment'}
                    ifNotes
                    notes={note}
                    isView={note ? true : false}
                />
            </div>
            <div className="details-overlay">
                <div className='new-orders-container' id="details-screen-boxs">
                    <div className='orders'>
                        <OrderShipmentDetailRow
                            customerName={customer || 'N/A'}
                            time={time}
                            orderDate={date}
                            orderValue={orderValue}
                            productUrl={url}
                            collectedOn={`${collectTime} on ${collectedDate}`}
                            orderRef={orderNumber}
                        />
                    </div >
                </div>
                <div className="top-space-details">
                    <div className='new-orders-container set-height' id="details-screen-boxs">
                        <div className='orders'>
                            <CustomerAddressRow
                                customerContactNo={customerAddress?.phone || 'N/A'}
                                address1={customerAddress?.address1 || "N/A"}
                                address2={customerAddress?.address2 || "N/A"}
                                postalCode={customerAddress?.zip || "N/A"}
                                city={customerAddress?.city || "N/A"}
                                country={customerAddress?.country || "N/A"}
                            />
                        </div >
                    </div>
                </div>
                <OrderItems data={data} isLoading={isLoading}/>
            </div>
        </div>
    )
}
